import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import {
  MEDIA_MIN_LG,
  MEDIA_MIN_MD,
  MEDIA_MIN_SM,
  MEDIA_MIN_XL,
  MEDIA_MIN_XS,
} from '../../lib/breakpoints'
import { SPACE_HALF, SPACE_QUARTER } from '../../lib/spaces'

const sizes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
const mediaQueries = ['xs', 'sm', 'md', 'lg', 'xl']

const MEDIA_MIN = {
  xs: MEDIA_MIN_XS,
  sm: MEDIA_MIN_SM,
  md: MEDIA_MIN_MD,
  lg: MEDIA_MIN_LG,
  xl: MEDIA_MIN_XL,
}

export default function LayoutCol({
  children,
  col,
  xs,
  sm,
  md,
  lg,
  xl,
  gutter = 'none',
  smallest = false,
  dynamicStyle,
}) {
  return (
    <div
      className={css(
        styles.col,
        col && styles[`col${col}`],
        xs && styles[`col_xs${xs}`],
        sm && styles[`col_sm${sm}`],
        md && styles[`col_md${md}`],
        lg && styles[`col_lg${lg}`],
        xl && styles[`col_xl${xl}`],
        gutter !== 'none' && styles[`gutter_${gutter}`],
        smallest && styles.smallest,
        dynamicStyle
      )}
    >
      {children}
    </div>
  )
}

const getStylingProperties = (size) => ({
  flex: `0 0 calc(100% / 12 * ${size})`,
  maxWidth: `calc(100% / 12 * ${size})`,
})

/**
 * * Provide the styling in each size (1 to 12) for each media query (xs to xl)
 */
const getDynamicMediaQueriesStyling = () => {
  const dynamicMediaQueries = {}

  sizes.forEach((size) => {
    dynamicMediaQueries[`col${size}`] = getStylingProperties(size)
  })

  mediaQueries.forEach((mediaQuery) => {
    sizes.forEach((size) => {
      dynamicMediaQueries[`col_${mediaQuery}${size}`] = {
        [MEDIA_MIN[mediaQuery]]: getStylingProperties(size),
      }
    })
  })

  return dynamicMediaQueries
}

const styles = StyleSheet.create({
  col: {
    boxSizing: 'border-box',
    flex: '1 1',
  },
  gutter_small: {
    paddingLeft: SPACE_QUARTER,
    paddingRight: SPACE_QUARTER,
  },
  gutter_large: {
    paddingLeft: SPACE_HALF,
    paddingRight: SPACE_HALF,
  },
  ...getDynamicMediaQueriesStyling(),
  smallest: {
    flex: 0,
  },
})

LayoutCol.propTypes = {
  children: PropTypes.node.isRequired,
  col: PropTypes.oneOf(sizes),
  xs: PropTypes.oneOf(sizes),
  sm: PropTypes.oneOf(sizes),
  md: PropTypes.oneOf(sizes),
  lg: PropTypes.oneOf(sizes),
  xl: PropTypes.oneOf(sizes),
  gutter: PropTypes.oneOf(['none', 'small', 'large']),
  smallest: PropTypes.bool,
  dynamicStyle: PropTypes.object,
}
